import { RG_TYPE, GetAllBones } from "@project-rouge/rg-core";
import { RgPipes } from "./index5.js";
import { RunPipeline } from "./index6.js";
import { getRgObjectsOfType } from "@project-rouge/rg-three";
function rebuildFromSkeleton({ obj, aggProps, buildingIds }) {
  const buildings = getRgObjectsOfType(obj, RG_TYPE.Building).filter((b) => buildingIds.includes(b.uuid));
  buildings.forEach((b) => {
    b.children = [];
  });
  buildings.forEach((b) => {
    const bones = GetAllBones(b.data.anatomy);
    bones.forEach((bone) => {
      bone.muscles = [];
    });
  });
  const pipeResult = RunPipeline({ obj, aggProps, from: RgPipes.AddMuscles, buildingIds });
  return pipeResult;
}
export {
  rebuildFromSkeleton
};
//# sourceMappingURL=index43.js.map
